/**
 * Created by jjing on 6/7/2017.
 */
import React, {Component} from 'react';
import {Button} from "antd";
import {Modal} from 'react-bootstrap';
import Constants from '../../../commons/Constants';

class ConfirmModal extends Component {

    constructor(props) {
        super(props);

        this.state = {showModal:false, status: Constants.STATUS.init};
    }

    close() {
        this.setState({ showModal: false });
    }

    open() {
        this.setState({ showModal: true });
    }

    setCallBack = (callback) => {
        this.callback = callback;
    }

    handleCallBack = () => {
        const callbackFun = this.props.callback || this.callback;
        callbackFun();
    }

    render = () => {
        const {title, body, isConfirm, isDelete}=this.props;
        const {status, errorMsg}=this.state;

        return (<Modal show={this.state.showModal} onHide={() => this.close()}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {body}
                <br/>
                {((status, errorMsg) => {
                    let errorLabel = "";
                    if(status===Constants.STATUS.error){
                        errorLabel=<span>Fail to handle Action</span>;
                        if(errorMsg){
                            errorLabel=<div>
                                {errorLabel}
                                <span>Detail: {errorMsg}</span>
                            </div>
                        }
                    }
                    return errorLabel;
                })(status, errorMsg)}
            </Modal.Body>
            <Modal.Footer>
                {isConfirm && !isDelete ? <Button size="large" loading={status===Constants.STATUS.trying} type="primary" onClick={() => this.handleCallBack()}>OK</Button> : ""}
                {isConfirm && isDelete ? <Button size="large" loading={status===Constants.STATUS.trying} type="danger" onClick={() => this.handleCallBack()}>Delete</Button> : ""}
                <Button size="large" onClick={() => {this.close();if(this.props.onCloseCallback) this.props.onCloseCallback()}} htmlType="button">Cancel</Button>
            </Modal.Footer>
        </Modal>);
    }
}

export default ConfirmModal;


// WEBPACK FOOTER //
// ./src/modules/policy/component/ConfirmModal.js